import React from "react";
import {
  officialStandards,
  standardsScope,
  standardsVerifiedDate,
  standardsVerifiedLabel,
} from "../../data/defensieStandards";

const OfficialStandardsSection = () => {
  const standard = officialStandards.cluster6;

  return (
    <section className="border-y border-mmBorder bg-mmPage px-5 py-14 text-mmText sm:px-10 lg:px-20">
      <div className="mx-auto max-w-5xl">
        <h2 className="mm-h2 mb-5">{standard.title}</h2>
        <p className="mb-5 text-mmTextMuted leading-relaxed">{standardsScope}</p>
        <p className="mb-5 text-mmTextMuted leading-relaxed">{standard.summary}</p>
        <dl className="space-y-5">
          {standard.requirements.map((requirement) => (
            <div key={requirement.id}>
              <dt className="font-semibold">{requirement.label}</dt>
              <dd className="mt-1 text-mmTextMuted leading-relaxed">
                {requirement.minimumLabel}.
                {requirement.protocol && ` ${requirement.protocol}`}
              </dd>
            </div>
          ))}
        </dl>
        <p className="mt-6 text-sm text-mmTextMuted leading-relaxed">{standard.note}</p>
        <p className="mt-5 text-sm text-mmTextMuted">
          Bron: <a href={standard.sourceUrl} className="text-mmAccent underline">{standard.sourceLabel}</a>.
          {" "}Laatst gecontroleerd: <time dateTime={standardsVerifiedDate}>{standardsVerifiedLabel}</time>.
        </p>
      </div>
    </section>
  );
};

export default OfficialStandardsSection;
